export default "__VITE_ASSET__f5801d96__"